import React from 'react'
import { useParams } from 'react-router-dom'
import { Container, Paper } from '@mui/material'
import { v4 as uuidv4 } from 'uuid'

import { Organization, OrganizationAISettings0 } from '~types'

import AIInteractionContent from '../components/AIInteractionContent'

// This is a fallback organization to use when viewing in anonymous mode
const DEFAULT_ORGANIZATION: Organization = {
  id: uuidv4(),
  identity: uuidv4(),
  parent: uuidv4(),
  name: null,
  image: null,
  logo: null,
  phone_number: null,
  information: '',
  font_color: '#000000',
  bg_color: '#FFFFFF',
  search_url: undefined,
  banner: undefined,
}

const DEFAULT_ORGANIZATION_AI_SETTINGS: OrganizationAISettings0 = {
  organization: DEFAULT_ORGANIZATION,
}

const AIInteractionViewerPage: React.FC = () => {
  const { chatId } = useParams<{ chatId: string }>()

  return (
    <Container maxWidth='md' sx={{ py: 4 }}>
      <Paper
        elevation={2}
        sx={{
          minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          backgroundColor: 'var(--lightoffwhite)',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <AIInteractionContent
          chatId={chatId || ''}
          orgSettings={DEFAULT_ORGANIZATION_AI_SETTINGS}
          showOrgInfo={true}
        />
      </Paper>
    </Container>
  )
}

export default AIInteractionViewerPage
